// extracted by mini-css-extract-plugin
export default {"slides-container":"SlidesScreen_slides-container__zpAe9","slides-iframe-container":"SlidesScreen_slides-iframe-container__ZhfRx","link-blocker":"SlidesScreen_link-blocker__hevwT"};